import { z } from 'zod';

export const LogoSchema = z.object({
  hash: z.string().optional()
});

export type LogoSchemaType = z.infer<typeof LogoSchema>;
